import {useTranslation} from "react-i18next";
import Divider from "antd/es/divider";
import {useEffect, useState} from "react";
import i18n from '../i18n'
import {Button, Card, Input, message} from "antd";
import { Typography } from "antd";
import {isValidCode} from "../util/util";
const { Title, Paragraph, Text } = Typography;

export default () => {

    const { t } = useTranslation()

    const [show, setShow] = useState(false)
    const isZh = i18n.language === 'zh'
    const [code, setCode] = useState("");


    useEffect(() => {

        setTimeout(() => {
            setShow(true)
        }, 200)
    }, [])

    return (<>

        {
            show && <>
                <Card style={{ maxWidth: 600, margin: "20px auto", padding: 24 }}>

                    <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
                        {isZh ? "订阅说明" : "Subscription Information"}
                    </div>

                    <div style={{ marginBottom: 12 }}>
                        {isZh ? (
                            <>
                                月费 <strong>$37</strong>，终身一次性付费 <strong>$260</strong>。<br />
                                您可以将付款发送到我的 PayPal 邮箱 <strong>ruyue147@gmail.com</strong>。<br />
                                激活码会发送到您用于付款的 PayPal 邮箱，请注意查收。<br />
                            </>
                        ) : (
                            <>
                                Monthly subscription <strong>$37</strong>, or lifetime one-time payment <strong>$260</strong>.<br />
                                You can send the payment to my PayPal email <strong>ruyue147@gmail.com</strong>.<br />
                                The activation code will be sent to the PayPal email you used for the payment, so please check your inbox. <br />
                            </>
                        )}
                    </div>

                    <Divider />

                    <div style={{ marginBottom: 8 }}>
                        {isZh ? "请输入收到的激活码：" : "Enter your activation code:"}
                    </div>

                    <Input
                        placeholder={isZh ? "激活码" : "Activation Code"}
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        style={{ marginBottom: 12 }}
                    />
                    <Button type="primary" block onClick={async () => {
                        const min = 200;
                        const max = 2000;

                        const randomInt = Math.floor(Math.random() * (max - min + 1)) + min
                        setTimeout(async () => {
                            if (await isValidCode(code)) {
                                message.success(isZh ? "激活成功" : "Success!").then(() => {
                                    localStorage.setItem('code', code)
                                    location.reload()
                                })
                            } else {
                                message.error(isZh ? "无效的激活码" : "Illegal activation code!").then()
                            }
                        }, randomInt)

                    }}>
                        {isZh ? "激活" : "Activate"}
                    </Button>
                </Card>
            </>
        }

    </>)

}
